import styled from 'react-emotion'
import { border, sidebarWidth, z } from '../style'

export const Sidebar = styled.div({
  label: 'Sidebar',

  borderRight: border,
  background: '#FFFFFF',

  width: sidebarWidth,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  '@media (max-width: 600px)': {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: z.sidebar,
    width: '100%'
  }
})
export default Sidebar
